import { useEffect } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";

const searchSchema = z.object({
  returnTo: z.string().optional().catch(undefined),
});

// Older API builds sent people here with the authorize URL in `returnTo`;
// the consent screen now lives at /oauth/authorize.
export const Route = createFileRoute("/oauth/login")({
  validateSearch: searchSchema,
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const { returnTo } = Route.useSearch();

  useEffect(() => {
    let query: Record<string, string> = {};
    try {
      const url = new URL(returnTo ?? "");
      if (url.pathname.endsWith("/oauth/authorize")) {
        query = Object.fromEntries(url.searchParams.entries());
      }
    } catch {
      query = {};
    }

    if (!query.client_id) {
      navigate({
        to: "/",
        search: {
          change_password_token: undefined,
          reset_password_token: undefined,
        },
      });
      return;
    }
    navigate({ to: "/oauth/authorize", search: query });
  }, [navigate, returnTo]);

  return null;
}
